import { default as api } from '../services/api';

const aiJobsApi = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/ai-jobs', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching AI jobs:', error);
      throw error;
    }
  },
};

export default aiJobsApi;